import {
  getPopWindowByLocation,
  IObjStr,
  pageGetPopWindowByLocation,
  operateBuried,
  voucherLogin,
  operateBuriedNoToken,
  clickConversionUpClickId,
  baseUserInfo,
} from '@/api/point';
import { storage } from '@/utils';
import { baseMethods } from '@/hooks/index';
import { stat } from 'fs';
import useClipboard from 'vue-clipboard3';
const { isPhone, toBase62 } = baseMethods();
const { toClipboard } = useClipboard();
const { VITE_USER_NODE_ENV } = import.meta.env;

export function goBack() {
  const popData = reactive({
    imgUrl: '',
    jumpUrl: '',
    jumpType: '',
    id: '',
  });

  async function getBackDialogInfo() {
    let res;
    try {
      res = await getPopWindowByLocation({ locationId: 53 });
    } catch (e) {
      return false;
    }
    if (res) {
      popData.imgUrl = res.imgUrl;
      popData.jumpUrl = res.jumpUrl;
      popData.jumpType = res.jumpType;
      popData.id = res.id;
      return true;
    } else {
      return false;
    }
  }
  async function getBackDialogInfoPage(locationId: number) {
    let res;
    try {
      res = await pageGetPopWindowByLocation({ locationId: locationId });
    } catch (e) {
      return false;
    }
    if (res) {
      popData.imgUrl = res.imgUrl;
      popData.jumpUrl = res.jumpUrl;
      popData.jumpType = res.jumpType;
      popData.id = res.id;
      return true;
    } else {
      return false;
    }
  }
  const addZero = (num: number) => {
    return num < 10 ? '0' + num : num;
  };
  const getDateTime = () => {
    const time = new Date();
    const Y = time.getFullYear() + '-';
    const M = addZero(time.getMonth() + 1) + '-';
    const D = addZero(time.getDate()) + ' ';
    const h = addZero(time.getHours()) + ':';
    const m = addZero(time.getMinutes()) + ':';
    const s = addZero(time.getSeconds());
    return `${Y}${M}${D}${h}${m}${s}`;
  };

  // 获取当前时间戳(秒)
  const getTimestampS = () => {
    return Date.parse(new Date().toString()) / 1000;
  };

  const route = useRoute();
  const getFlag = async () => {
    if (route.query.voucher || (route.query.defined && route.query.defined != 'null')) {
      const token = storage.getItem('token', 2);
      if (token) {
        pointFn();
      } else {
        voucherLogin({ voucher: route.query.voucher as string }).then((res) => {
          console.log(res, '60');
          if (res.token) {
            storage.setItem('token', res.token, null, 2);
            pointFn();
          }
        });
      }
      const userInfo = await baseUserInfo();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const userId = toBase62(Number(userInfo.userId));
      storage.setItem('userId', userId, null, 2);
    } else {
      /** 20240319 guide 添加PV/UV埋点 */
      setTimeout(() => {
        const fromPageCode = route.query.fromPageCode as string;
        const comParams: IObjStr = {
          eventCode: 'JR_H5_USER_PAGE_VIEW',
          currentPageCode: 'ysr100005',
          currentPageName: '下载页',
          fromPageCode: fromPageCode as string,
          fromPageName: '',
          appName: 'new-yousurong',
          logTime: getDateTime(),
          extraDataJson: JSON.stringify({
            burSystem: 1,
          }),
          pageFlag: route.query.flag as string,
        };
        /** 无token pv埋点 */
        operateBuriedNoToken(getParams(fromPageCode, comParams));
      }, 500);
    }
  };
  const pointFn = () => {
    setTimeout(() => {
      const fromPageCode = route.query.fromPageCode as string;
      const comParams: IObjStr = {
        eventCode: 'JR_H5_USER_PAGE_VIEW',
        currentPageCode: 'ysr100005',
        currentPageName: '下载页',
        fromPageCode: fromPageCode as string,
        fromPageName: '',
        appName: 'new-yousurong',
        logTime: getDateTime(),
        extraDataJson: JSON.stringify({
          burSystem: 1,
        }),
        pageFlag: route.query.flag as string,
      };
      operateBuried(getParams(fromPageCode, comParams));
      /** 区别精准访问 eventCode */
      operateBuriedNoToken(getParams(fromPageCode, comParams, 'JR_H5_USER_PAGE_VIEW_TRUE'));
    }, 500);
  };

  const getParams = (fromPageCode: string, comParams: IObjStr, eventCode?: string) => {
    if (fromPageCode == 'ysr100001') {
      comParams.fromPageName = '访问页';
    } else if (fromPageCode == 'ysr100002') {
      comParams.fromPageName = '信贷留资页';
    } else if (fromPageCode == 'ysr100003') {
      comParams.fromPageName = '提交审核页';
    } else if (fromPageCode == 'ysr100007') {
      comParams.fromPageName = '撞库成功页';
    }
    if (eventCode) {
      comParams.eventCode = eventCode;
    }
    return comParams;
  };
  const pointDownloadFn = (
    isPoint: boolean,
    downloadType?: number,
    applyClick?: number,
    automaticDownload?: number,
    packageName?: string,
    pageFlag?: string
  ) => {
    if (!isPoint) {
      return;
    }
    const fromPageCode = route.query.fromPageCode as string;
    const comParams: IObjStr = {
      eventCode: 'JR_H5_DOWNLOAD',
      currentPageCode: 'ysr100005',
      currentPageName: '下载页',
      fromPageCode: fromPageCode as string,
      fromPageName: '',
      appName: 'new-yousurong',
      logTime: getDateTime(),
      extraDataJson: JSON.stringify({
        downloadType: downloadType,
        applyClick: applyClick,
        automaticDownload: automaticDownload,
        packageName: automaticDownload ? packageName : '',
      }),
      pageFlag: pageFlag ? pageFlag : (route.query.flag as string),
    };
    operateBuriedNoToken(getParams(fromPageCode, comParams));
    /** 上报clickId */
    upClickIdFn();

    /** 写入剪贴板 */
    guideToClipboard();
  };
  const jumpAppInH5 = (callBack: any) => {
    setTimeout(() => {
      callBack();
    }, 2000);
  };

  const upClickIdFn = () => {
    const clickId_ = storage.getItem('clickId', 2);
    if (!clickId_) {
      return;
    }
    clickConversionUpClickId({ clickId: clickId_, timeStamp: getTimestampS().toString() });
  };

  /** 写入粘贴板 */
  const guideToClipboard = async () => {
    const userId_ = storage.getItem('userId', 2) || '';
    const clickId_ = storage.getItem('clickId', 2) || '';
    const channelId_ = storage.getItem('channelId', 2);
    console.log(channelId_, '--', clickId_, '--', userId_);
    await toClipboard(`XDCHANNELDI-${channelId_}&-288888888&${userId_}&${clickId_}`);
  };

  const openInstallThis = ref<any>();

  const initOpenInstall = (isAddPb = false, isAuto = true) => {
    const openId = VITE_USER_NODE_ENV == 'production' ? 'clj5ew' : 'j0lxra';
    const bannerId =
      VITE_USER_NODE_ENV == 'production' ? '732372161962930248' : '874075513145779309';
    const scriptAPP = document.createElement('script');
    scriptAPP.src = 'https://web-' + openId + '.openinstall.com/web/banner.js?id=' + bannerId;
    document.head.appendChild(scriptAPP);
    const scripta = document.createElement('script');
    scripta.src = 'https://web.cdn.openinstall.io/openinstall.js';
    scripta.onload = function () {
      const channelId_ = storage.getItem('channelId', 2);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const data = OpenInstall.parseUrlParams();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      new OpenInstall(
        {
          //初始化方法，与openinstall服务器交互，应尽早调用
          appKey: openId, //appKey为openinstall为应用分配的唯一id（必须传入）
          channelCode: channelId_, //传入渠道编号，优先级大于链接上拼接的渠道编号
          fastInstall: false, //快速安装功能开关，true为开启，false为关闭
          onready: function () {
            openInstallThis.value = this;
            const fromPageCode = route.query.fromPageCode as string;
            if (isAddPb) {
              const params: IObjStr = {
                currentPageCode: 'ysr100005',
                currentPageName: '下载页',
                fromPageCode: fromPageCode as string,
                fromPageName: '',
                logTime: getDateTime(),
                appName: 'new-yousurong',
                eventCode: 'JR_H5_API_TRACK_MODE',
                extraDataJson: JSON.stringify({
                  trackCode: isPhone() == 'IOS' ? 2 : 1,
                  trackName: `下载页默认触发下载次数(${isPhone() == 'IOS' ? 'ios' : '安卓'})`,
                }),
                pageFlag: (route.query.flag as string) || '',
              };
              operateBuriedNoToken(getParams(fromPageCode, params));
            }
            const comParams: IObjStr = {
              eventCode: 'JR_H5_DOWNLOAD',
              currentPageCode: 'ysr100005',
              currentPageName: '下载页',
              fromPageCode: fromPageCode as string,
              fromPageName: '',
              appName: 'new-yousurong',
              logTime: getDateTime(),
              extraDataJson: JSON.stringify({
                downloadType: isPhone() == 'IOS' ? 3 : 0,
                applyClick: 0,
                automaticDownload: isPhone() == 'IOS' ? 0 : 1,
                packageName: 'openInstall',
              }),
              pageFlag: (route.query.flag as string) || '',
            };
            operateBuriedNoToken(getParams(fromPageCode, comParams));
            console.log('openinstall初始化完成');
            upClickIdFn();
            if (isAuto) {
              this.schemeWakeup(); //尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
              setTimeout(() => {
                guideToClipboard();
                this.wakeupOrInstall();
              }, 1500);
            }
          },
        },
        data
      );
    };
    document.head.appendChild(scripta);
  };
  const wakeupOrInstall = (time = 500) => {
    openInstallThis.value.schemeWakeup(); //尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
    setTimeout(() => {
      openInstallThis.value.wakeupOrInstall();
    }, time);
  };

  return {
    getBackDialogInfoPage,
    getBackDialogInfo,
    popData,
    getFlag,
    getDateTime,
    pointDownloadFn,
    jumpAppInH5,
    initOpenInstall,
    openInstallThis,
    wakeupOrInstall,
  };
}
